export default "__VITE_ASSET__8dddffb9__"